import * as React from 'react';
import * as styles from './Cover.css';
import { IComposerImage } from '../../../interfaces/IComposerImage';
import { LocalizationService } from '../../../services/LocalizationService';
import { IComposerVideo } from '../../../interfaces/IComposerVideo';
import { inject, observer } from 'mobx-react';
import { Store } from '../stores';
import { Image } from '../image/Image';
import { Video } from '../video/Video';
import { IAComposerPlaceholder } from '../placeholders/ComposerPlaceholder';

export interface IProps {
  store?: Store;
  id: string;
  image: IComposerImage;
  isMobile: boolean;
  video: IComposerVideo;
  typeToEdit: string;
  hideToolbox: boolean;
  showDropZones: boolean;
  isInMobileToolbox?: boolean;
  onChangeImage: (cover: IComposerImage) => void;
  onChangeVideo: (cover: IComposerVideo) => void;
  onFocus: () => void;
}

export interface IState {
  showImageCropper: boolean;
}

@inject('store')
@observer
export class Cover extends React.Component<IProps, IState> {
  private readonly localizationService: LocalizationService = new LocalizationService();

  constructor(props: IProps) {
    super(props);
    this.state = {
      showImageCropper: false,
    }
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
    if (!this.props.store.isMobile) {
      document.body.addEventListener('onmousedown', (event: any) => {
        var exceptions = '#IA_Cover *, #IA_toolboxContent *, #IA_OrgAssetsUploader *, #IA_StockPhotos *';
        if (!event.target.matches(exceptions) && this.props.store.activeComponent && this.props.store.activeComponent.type === "cover") {
          this.props.store.activeComponent = undefined;
        }
      });
    }
  }

  public render(): JSX.Element {
    const showInitialPlaceholder = this.props.store.activeComponent?.id !== this.props.id && !this.props.image?.url && !this.props.video?.url && !this.props.video?.embedCode;
    return (
      <div
        id="IA_Cover"
        className={styles.IA_cover}
        style={{
          width: this.props.isMobile ? (this.props.isInMobileToolbox ? "100%" : "calc(100% - 80px)") : 620,
          height: this.state.showImageCropper ? "auto" : (this.props.isMobile ? (screen.width - 100) / 16 * 9 : 349),
          margin: this.props.isMobile && this.props.isInMobileToolbox ? "0px 0px 10px" : (this.props.store.isNewsLink ? "20px 40px 10px 0" : "20px 40px 10px")
        }}
        onClick={() => {
          this.props.onFocus();
        }}
      >
        {showInitialPlaceholder ?
          <IAComposerPlaceholder
            id={this.props.id}
            highlightColor={this.props.store.highlightColor}
            isActive={false}
            onClick={() => this.props.onFocus()}
            text={this.props.store.component === "Messages" ? this.localizationService.strings.Composer_CoverInfo : this.localizationService.strings.Composer_CoverInfoEvents}
            borderRadius={5}
            icon={{
              name: "Picture",
              size: 60
            }}
          />
          :
          <>
            {(this.props.typeToEdit === "image" || (this.props.typeToEdit == undefined && this.props.image && this.props.image?.url && (this.props.video && (this.props.video?.url == undefined || this.props.video.embedCode == undefined)))) ?
              <Image
                id={this.props.id}
                image={this.props.image}
                hideToolbox={this.props.hideToolbox}
                showDropZones={this.props.showDropZones}
                isCover
                isInMobileToolbox={this.props.isInMobileToolbox}
                onChange={(image) => this.props.onChangeImage(image)}
                onFocus={() => this.props.onFocus()}
                onToggleCropper={(showImageCropper) => this.setState({ showImageCropper })}
              />
              :
              <Video
                id={this.props.id}
                video={this.props.video}
                hideToolbox={this.props.hideToolbox}
                showDropZones={this.props.showDropZones}
                isCover
                onChange={(video) => this.props.onChangeVideo(video)}
                onFocus={() => this.props.onFocus()}
              />
            }
          </>
        }
      </div>
    );
  }


}